import React from 'react';
import {
    getFieldValue,
    RichText,
    Text,
} from '@sitecore-jss/sitecore-jss-react';
import buildClassNames from 'classnames';
import Tier from '../../components-common/Tier';
import { COMPONENT_BG_COLOR } from '../../utilities/themeColor';

const HomeFreeTextBlock = ({ fields }) => {
    const theme = getFieldValue(fields, 'theme');
    // TODO: Implement theming in the manner that MHF has done
    // Dark theme will get hoisted up to a global constant
    const isDarkTheme =
        theme === COMPONENT_BG_COLOR.DARK_GRAY ||
        theme === COMPONENT_BG_COLOR.BLUE;

    return (
        <Tier theme={theme}>
            <div className="grid grid--gutter-2x">
                <div className="grid__col grid__col--4of12@lg">
                    {fields.leftlabel && (
                        <Text
                            tag="h2"
                            className="hdg hdg--3 hdg--weight-regular hdg--fancy-line"
                            field={fields.leftlabel}
                        />
                    )}
                </div>
                <div className="grid__col grid__col--8of12@lg">
                    {fields.title && (
                        <RichText
                            className={buildClassNames('rich-text', {
                                'rich-text--dark-theme': isDarkTheme,
                            })}
                            field={fields.title}
                        />
                    )}
                </div>
            </div>
        </Tier>
    );
};

export default HomeFreeTextBlock;
